export default __webpack_public_path__ + "static/hero-joined-6054fcf4932bf6f20f432169f142e65d.png";